import React from 'react';
import { useSortable } from '@dnd-kit/sortable';

export default function DragHandle({ id }: { id: string | number }) {
    const { attributes, listeners } = useSortable({ id });

    return (
        <span
            {...attributes}
            {...listeners}
            style={{ cursor: 'grab', display: 'inline-block' }}>
            ☰
        </span>
    );
}
